/**
 * Configuration des présets de dépenses
 * Chaque preset définit :
 * - icon: Icône Font Awesome associée
 * - title: Titre du formulaire
 * - fields: Champs spécifiques au type de dépense
 * - defaultValues: Valeurs par défaut pour certains champs
 * - validationRules: Règles de validation spécifiques
 */

const expensePresets = {
  // Preset pour les dépenses de type "Avion"
  plane: {
    icon: "fa-solid fa-plane-departure",
    title: "Frais de vol",
    fields: [
      {
        id: "lieu_depart_avion",
        label: "Lieu de départ",
        type: "text",
        required: true,
        placeholder: "Ex: Paris"
      },
      {
        id: "lieu_arrivee_avion",
        label: "Lieu d'arrivée",
        type: "text",
        required: true,
        placeholder: "Ex: New York"
      }
    ],
    defaultValues: {
      description: "Frais de vol"
    }
  },

  // Preset pour les dépenses de type "Distance/Kilomètres"
  distance_km: {
    icon: "fa-solid fa-location-dot",
    title: "Frais kilométriques",
    noTva: true, // Pas de TVA pour les frais kilométriques
    specialComponents: true, // Indiquer que ce preset utilise des composants spéciaux
    fields: [
      {
        id: "lieu_depart_dkm",
        label: "Adresse de départ",
        type: "address",
        required: true,
        placeholder: "Commencez à taper l'adresse de départ...",
        icon: "fa-solid fa-play"
      },
      {
        id: "destination_dkm",
        label: "Adresse d'arrivée",
        type: "address",
        required: true,
        placeholder: "Commencez à taper l'adresse d'arrivée...",
        icon: "fa-solid fa-flag-checkered"
      },
      {
        id: "distance_parcourue",
        label: "Distance parcourue (km)",
        type: "number",
        required: true,
        placeholder: "Calculée automatiquement",
        readonly: true, // Calculée automatiquement
        step: "0.1"
      },
      {
        id: "taux_kilometrique",
        label: "Taux kilométrique (€/km)",
        type: "number",
        required: true,
        step: "any",
        readonly: true // Bloquer la modification du taux
      }
    ],
    defaultValues: {
      taux_kilometrique: 0.631,
      description: "Frais kilométriques"
    }
  },

  // Preset pour les dépenses de type "Carburant"
  carburant: {
    icon: "fa-solid fa-gas-pump",
    title: "Frais de carburant",
    fields: [
      {
        id: "litres",
        label: "Litres de carburant",
        type: "number",
        required: false,
        step: "0.01",
        placeholder: "Quantité en litres"
      },
      {
        id: "prix_par_litre",
        label: "Prix par litre (€/L)",
        type: "number",
        required: false,
        step: "0.001",
        placeholder: "Prix unitaire"
      }
    ],
    defaultValues: {
      description: "Frais de carburant"
    }
  },

  // Preset pour les dépenses de type "Hôtel"
  hotel: {
    icon: "fa-solid fa-hotel",
    title: "Frais d'hébergement",
    fields: [
      {
        id: "nom_hotel",
        label: "Nom de l'hôtel",
        type: "text",
        required: true,
        placeholder: "Ex: Hôtel Mercure"
      },
      {
        id: "date_depart_hotel",
        label: "Date de départ",
        type: "date",
        required: true
      }
    ],
    defaultValues: {
      description: "Frais d'hébergement",
      tva: 10 // TVA par défaut à 10% pour les hôtels
    }
  },

  // Preset pour les dépenses de type "Location de véhicule"
  carRental: {
    icon: "fa-solid fa-hand-holding-dollar",
    title: "Location de véhicule",
    fields: [
      {
        id: "date_fin_loc",
        label: "Date de fin",
        type: "date",
        required: true
      },
      {
        id: "societe_location",
        label: "Société de location",
        type: "text",
        required: true,
        placeholder: "Ex: Europcar"
      }
    ],
    defaultValues: {
      description: "Location de véhicule"
    }
  },

  // Preset pour les dépenses de type "Restaurant"
  restaurant: {
    icon: "fa-solid fa-utensils",
    title: "Frais de restauration",
    fields: [
      {
        id: "nom_restaurant",
        label: "Nom du restaurant",
        type: "text",
        required: true,
        placeholder: "Nom du restaurant"
      },
      {
        id: "nb_invites",
        label: "Nombre d'invités",
        type: "number",
        required: false,
        placeholder: "Hors vous-même"
      }
    ],
    defaultValues: {
      description: "Frais de restauration",
      tva: 10 // TVA par défaut à 10% pour les restaurants
    }
  },

  // Preset pour les dépenses de type "Taxi"
  taxi: {
    icon: "fa-solid fa-taxi",
    title: "Frais de taxi",
    fields: [
      {
        id: "lieu_depart_taxi",
        label: "De",
        type: "text",
        required: true,
        placeholder: "Ex: Aéroport"
      },
      {
        id: "destination_taxi",
        label: "à",
        type: "text",
        required: true,
        placeholder: "Ex: Hôtel"
      }
    ],
    defaultValues: {
      description: "Frais de taxi",
      tva: 10 // TVA par défaut à 10% pour les transports
    }
  },

  // Preset pour les dépenses de type "Autres"
  other: {
    icon: "fa-solid fa-question",
    title: "Autres frais",
    fields: [],
    defaultValues: {
      description: ""
    }
  }
};

export default expensePresets; 